import { useEffect, useState } from "react";
import { Alert, Box, Button, TextField, Typography } from '@mui/material';
import HydrotestLogo from '../../assets/logo-hydrotest.png';

import { DB, Constant } from "../../constants";
import { ApiConfig } from '../../configuration';
import NavigationBar from '../NavigationBar';
import { DetectNetwork, BusinessLogic } from '../../utilities';
import { aesUtil } from '../../utilities/AesEncryptDecrypt';
import { CustomizedDialog } from '../../components';
import './style.css';
import { useTranslation } from 'react-i18next';

const LoginPage = () => {
    const { online } = DetectNetwork();
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [alertInvalidMessage, setAlertInvalidMessage] = useState(false);
    const [requiredUsernameAlert, setRequiredUsernameAlert] = useState(false);
    const [requiredPasswordAlert, setRequiredPasswordAlert] = useState(false);
    const [modalBody, setModalBody] = useState();
    const { t: translate } = useTranslation();

    const handleLogIn = async (event) => {
        event.preventDefault();

        try {
            if (username === "") {
                return setRequiredUsernameAlert(true);
            }
            if (password === "") {
                return setRequiredPasswordAlert(true);
            }
            if (online) {
                const res = await BusinessLogic.loginUser(username, password)

                if (res.isSucess) {
                    localStorage.setItem(Constant.localStorageKey.autoSync, true)
                    window.location.replace(process.env.PUBLIC_URL.length === 0 ? "/" : process.env.PUBLIC_URL);
                }
                else {
                    if (res.message.length > 0) {
                        setOpenModal(true)
                        setModalBody(
                            <Typography>{res.message}</Typography>
                        )
                        return
                    }
                    else {
                        setAlertInvalidMessage(true);
                        setTimeout(() => {
                            setAlertInvalidMessage(false);
                        }, 3000);
                        localStorage.setItem(Constant.localStorageKey.isLoggedIn, false);
                    }
                }
            }
            else {
                handleLogInOffline();
            }
        } catch (e) {
            console.log(e)
            setOpenModal(true);
            if (e.code === "ERR_NETWORK") {
                setModalBody(
                    <Typography>{translate('noConnection')}</Typography>
                )
            }
            else {
                setModalBody(
                    <Typography>Quelque chose s'est mal passé sur notre système.</Typography>
                )
            }
        }
    }

    const handleLogInOffline = async () => {
        const usersDataQuery = await DB.users.toArray();
        const loggedInUserInfo = usersDataQuery.filter((user) => user.data.personnel_controleur.nom === username);
        if (loggedInUserInfo.length > 0) {
            //Get logged in user infos
            const loggedInUserName = loggedInUserInfo[0].data.personnel_controleur.nom;
            const encryptedLoggedInPassword = loggedInUserInfo[0].passe;
            const decryptedLoggedInPassword = aesUtil.decrypt(ApiConfig.AesSecretKey, encryptedLoggedInPassword);
            const userId = loggedInUserInfo[0].data.personnel_controleur.id;

            localStorage.setItem(Constant.localStorageKey.userId, userId);
            localStorage.setItem(Constant.localStorageKey.updateDone, true)
            if (username === loggedInUserName && password === decryptedLoggedInPassword) {
                localStorage.setItem(Constant.localStorageKey.isLoggedIn, true);
                // localStorage.setItem(Constant.localStorageKey.lastUpdate, "0000-00-00 00:00:00")
                window.location.replace(process.env.PUBLIC_URL.length === 0 ? "/" : process.env.PUBLIC_URL);
            } else {
                setAlertInvalidMessage(true);
                setTimeout(() => {
                    setAlertInvalidMessage(false);
                }, 3000);
                localStorage.setItem(Constant.localStorageKey.isLoggedIn, false);
            }
        } else {
            return handleOpenModal();
        }
    }

    const handleCloseMessage = () => {
        setAlertInvalidMessage(false);
    }

    const [openModal, setOpenModal] = useState(false);

    const handleOpenModal = () => {
        setOpenModal(true);
        setModalBody(
            <Typography>Pas de connexion internet, le compte que vous avez essayé n'est pas reconnu par l'application.</Typography>
        )
    }

    useEffect(() => {
        localStorage.setItem(Constant.localStorageKey.isLoggedIn, false);
    }, [])


    return (
        <div>
            <NavigationBar showToolBar={false} showNavBar={false} />
            <form onSubmit={handleLogIn} className="login-form" spacing={2}>
                <Box
                    className='login-box'
                    display="flex"
                    flexDirection={"column"}
                    maxWidth={450}
                    justifyContent={"center"}
                    alignItems="center"
                    margin="auto"
                    marginTop={10}
                    padding={4}
                    sx={{
                        boxShadow: 2,
                        borderRadius: 2,
                        marginBottom: '10px'
                    }}
                >
                    <img alt='' className='hydro-logo' src={HydrotestLogo} />
                    <TextField
                        autoComplete="off"
                        id='usernameInput'
                        error={requiredUsernameAlert ? true : false}
                        helperText={requiredUsernameAlert ? translate('fieldRequire') : null}
                        sx={{ width: '100%' }}
                        label={translate('username')}
                        onChange={(e) => {
                            setUsername(e.target.value);
                            setRequiredUsernameAlert(false);
                            setAlertInvalidMessage(false);
                        }}
                        margin='normal'
                        type='text'
                        placeholder={translate('username')}
                    />
                    <TextField
                        autoComplete="off"
                        id='passwordInput'
                        error={requiredPasswordAlert ? true : false}
                        helperText={requiredPasswordAlert ? translate('fieldRequire') : null}
                        sx={{ width: '100%' }}
                        label={translate('password')}
                        onChange={(e) => {
                            setPassword(e.target.value);
                            setRequiredPasswordAlert(false);
                            setAlertInvalidMessage(false);
                        }}
                        margin='normal'
                        type='password'
                        placeholder={translate('password')}
                    />
                    <Button type='submit' sx={{ '&:hover': { backgroundColor: "#fbc500" }, color: 'black', marginTop: 3, width: '100%', padding: "10px", backgroundColor: '#fbd200', boxShadow: 'none' }} variant='contained'>{translate('connect')}</Button>
                </Box>
            </form>
            {
                alertInvalidMessage && !requiredUsernameAlert && !requiredPasswordAlert ?
                    <div className='alert-message'>
                        <Alert severity="error" style={{ width: '100%' }} onClose={handleCloseMessage} >{translate('invalidUsernameOrPassword')}</Alert>
                    </div>
                    : null
            }
            <CustomizedDialog
                open={openModal}
                title={translate('alert')}
                showActionButton={true}
                closeBtnLabel="Ok"
                onClose={() => {
                    setOpenModal(false);
                }}
            >
                {modalBody}
            </CustomizedDialog>
        </div>
    );
}

export default LoginPage;